import React, {useEffect, useContext} from "react";
import { MyContext } from "../../../MyContext";
import { useNavigate } from "react-router-dom";
import ApiKey from "./ApiKey";
import KeyManagement from "./KeyManagement";

function AccountSetings() {

  const { onPage, setOnPage } = useContext(MyContext)!;
  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
  }, []);


  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Account Settings</h2>
        </div>
      </div>
      <div className="col-content">
        <div className="notifications-container">
          <ApiKey />
          <KeyManagement />
        </div>
      </div>
    </>
  );
}

export default AccountSetings;
